import React, { useState, useEffect } from "react";
import { NAV_LINKS, CALENDLY_URL, PHONE, PHONE_TEL, LOGO_URL } from "@/lib/siteData";
import { Phone, Menu, X, CalendarCheck } from "lucide-react";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-navbar"
      className={`fixed top-0 left-0 right-0 z-40 transition-all duration-300 ${
        scrolled
          ? "bg-md-bg/90 backdrop-blur-md border-b border-md-border/70 shadow-sm"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-2 flex items-center justify-between">
        <a
          href="#hero"
          data-testid="navbar-logo"
          className="flex items-center gap-3 group"
        >
          <img
            src={LOGO_URL}
            alt="MD Courtage"
            className="h-20 md:h-24 w-auto object-contain"
          />
        </a>

        <nav className="hidden lg:flex items-center gap-7">
          {NAV_LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.label.toLowerCase()}`}
              className="text-sm text-md-primary/80 hover:text-md-secondary transition-colors"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="hidden md:flex items-center gap-3">
          <a
            href={`tel:${PHONE_TEL}`}
            data-testid="navbar-phone"
            className="flex items-center gap-2 text-md-primary/90 hover:text-md-secondary text-sm font-medium"
          >
            <Phone className="w-4 h-4" />
            {PHONE}
          </a>
          <a
            href={CALENDLY_URL}
            target="_blank"
            rel="noreferrer"
            data-testid="navbar-cta-rdv"
            className="inline-flex items-center gap-2 bg-md-secondary hover:bg-md-secondaryHover text-white px-5 py-2.5 rounded-full text-sm font-semibold transition-all hover:shadow-lg hover:-translate-y-0.5"
          >
            <CalendarCheck className="w-4 h-4" />
            Prendre RDV
          </a>
        </div>

        <button
          data-testid="navbar-mobile-toggle"
          className="lg:hidden text-md-primary"
          onClick={() => setOpen((v) => !v)}
          aria-label="Menu"
        >
          {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden bg-md-bg border-t border-md-border px-6 py-6 space-y-4" data-testid="mobile-menu">
          {NAV_LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              onClick={() => setOpen(false)}
              className="block text-md-primary text-base"
            >
              {l.label}
            </a>
          ))}
          <a
            href={CALENDLY_URL}
            target="_blank"
            rel="noreferrer"
            className="block bg-md-secondary text-white text-center px-5 py-3 rounded-full font-semibold"
          >
            Prendre RDV
          </a>
        </div>
      )}
    </header>
  );
}
